import { useTranslation } from 'react-i18next';
import { Card } from '../atoms/Card.js';
import { Typography } from '../atoms/Typography.js';
import { Badge } from '../atoms/Badge.js';
import type { Question } from '../../types/survey.js';

interface QuestionListProps {
  questions: Question[];
  className?: string;
}

export function QuestionList({ questions, className = '' }: QuestionListProps) {
  const { t } = useTranslation('dashboard');
  const sorted = [...questions].sort((a, b) => a.order - b.order);

  return (
    <div className={className}>
      <Typography variant="h4" className="mb-4">
        {t('questions.title')}
      </Typography>

      {sorted.length === 0 ? (
        <Typography variant="body-sm" className="text-center py-8">
          {t('questions.empty')}
        </Typography>
      ) : (
        <div className="flex flex-col gap-3">
          {sorted.map((q, index) => (
            <Card key={q.id}>
              <div className="flex items-start gap-3">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-sm font-semibold text-primary-700">
                  {index + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <Typography variant="body">{q.text}</Typography>
                  <div className="mt-2 flex items-center gap-2">
                    {q.required && <Badge variant="warning">{t('questions.required')}</Badge>}
                    {q.followUpPrompt && (
                      <Badge variant="info">{t('questions.has_followup')}</Badge>
                    )}
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
